import { Component, ElementRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { ConversionService } from '../../../../services/api/conversion.service';
import { ChartComponent, PieChartModel, XYChartModel } from '@ngx-seatback/charts';
import { UtilService } from '../../../../services/util.service';
import { ActivatedRoute } from '@angular/router';
import { StringTransformationService } from '../../../../services/transformation-helper/string-transformation.service';

@Component({
  selector: 'app-share-of-voice-content',
  templateUrl: './share-of-voice-content.component.html',
  styleUrls: ['./share-of-voice-content.component.scss'],
  standalone: false,
})
export class ShareOfVoiceContentComponent implements OnInit {
  readonly stringTransformation = inject(StringTransformationService);

  @ViewChild('playerLineChartLegend', { read: ElementRef, static: true }) playerLineChartLegendContainer: ElementRef;
  @ViewChild('visitorLineChartLegend', { read: ElementRef, static: true }) visitorLineChartLegendContainer: ElementRef;
  @ViewChild('pieChart') pieChart: ChartComponent;
  @ViewChild('visitorLineChart') visitorLineChart: ChartComponent;
  @ViewChild('visitorHeatmap') visitorHeatmap: ChartComponent;
  @ViewChild('playerHeatmap') playerHeatmap: ChartComponent;
  @ViewChild('playerLineChart') playerLineChart: ChartComponent;
  @Input() from;
  @Input() till;
  shareOfVoiceMode: string | undefined;

  // tslint:disable-next-line:variable-name
  _reportingObj: any;
  @Input() set reportingObj(val: any) {
    this._reportingObj = val;
    this.generateCharts();
  }

  get reportingObj(): any {
    return this._reportingObj;
  }

  @Input() selectedField: string;
  @Input() loading: boolean;
  _playoutsNumber: boolean;
  @Input() set playoutsNumber(val: boolean) {
    this._playoutsNumber = val;
    this.buildPieChart();
  }

  get playoutsNumber(): boolean {
    return this._playoutsNumber;
  }

  pieChartData: PieChartModel = {
    title: 'lcdType',
    height: 200,
    width: 100,
    value: 'value',
    category: 'category',
    fontSize: 18,
    radius: 60,
    sumLabel: false,
    customLabel: '',
    data: [],
  };
  playerLineChartData: XYChartModel = {
    title: 'Test',
    height: 500,
    valueAssignments: [
      {
        value: 'playouts', // y
        categories: ['date'], // x
        valueName: 'Playouts',
        color: '#8950fc',
        ownAxis: true,
      },
      /*
                                                                                                            {
                                                                                                              value: 'playbacktime',
                                                                                                              categories: ['date'],
                                                                                                              valueName: 'Playbacktime',
                                                                                                              color: '#8950fc',
                                                                                                              ownAxis: false,
                                                                                                            },
                                                                                                          /*      {
                                                                                                              value: 'screens',
                                                                                                              categories: ['date'],
                                                                                                              valueName: 'screens',
                                                                                                              color: '#fc3d53',
                                                                                                              ownAxis: true,
                                                                                                              opposite: true
                                                                                                            } */
    ],
    legend: false,
    showBullet: true,
    data: [],
    tensionX: 1,
  };

  visitorLineChartData: XYChartModel = {
    title: 'Test',
    height: 500,
    valueAssignments: [
      {
        value: 'visitors',
        categories: ['date'],
        valueName: 'Visitors',
        color: '#8950fc',
        ownAxis: true,
      },
      {
        value: 'impressions',
        categories: ['date'],
        valueName: 'Impressions',
        color: '#2cc361',
        ownAxis: false,
      },
    ],
    legend: true,
    showBullet: true,
    data: [],
    tensionX: 1,
  };

  playerHeatmapData: XYChartModel = {
    title: 'Heatmap',
    height: 500,
    width: 100,
    legend: false,
    data: [],
    valueAssignments: [
      {
        value: 'totalPlayouts',
        valueName: 'Heatmap',
        color: '#8950fc',
        categories: ['date', 'hour'],
      },
    ],
  };

  visitorHeatmapData: XYChartModel = {
    title: 'Heatmap',
    height: 500,
    width: 100,
    legend: false,
    data: [],
    valueAssignments: [
      {
        value: 'visitors',
        valueName: 'Visitors',
        color: '#2cc361',
        categories: ['date', 'hour'],
      },
    ],
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private conversionService: ConversionService,
    public util: UtilService
  ) {}

  parseTime(time: number): string {
    return this.util.parseTimeToDuration(time);
  }

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.toString().indexOf('publisher-share-of-voice') !== -1) {
      this.shareOfVoiceMode = 'publisher';
    } else {
      this.shareOfVoiceMode = 'advertiser';
    }
  }

  generateCharts() {
    if (this.reportingObj?.report?.byDate) {
      this.buildPlayerLineChart(this.playerLineChartData, this.playerLineChartLegendContainer);
      if (this.playerLineChart) {
        this.playerLineChart.rerenderChart(this.playerLineChartData);
      }
      this.buildPlayerLineChart(this.visitorLineChartData, this.visitorLineChartLegendContainer);
      if (this.visitorLineChart) {
        this.visitorLineChart.rerenderChart(this.visitorLineChartData);
      }
      this.buildPieChart();
      this.buildHeatmap(this.playerHeatmapData);
      if (this.playerHeatmap) {
        this.playerHeatmap.rerenderChart(this.playerHeatmapData);
      }
      this.buildHeatmap(this.visitorHeatmapData);
      if (this.visitorHeatmap) {
        this.visitorHeatmap.rerenderChart(this.visitorHeatmapData);
      }
    }
  }

  // workaround
  buildPlayerLineChart(obj, legendContainer?) {
    obj.data = [];
    obj.categoryType = 'date';
    for (const report of this.reportingObj.report.byDate) {
      const o = {
        date: this.conversionService.prepareObject(report.r0),
        playouts: report.v0,
        playbacktime: report.v1,
        visitors: report.v2,
        uniqueVisitors: report.v3,
        impressions: report.v4,
        screens: report.v5,
      };
      /*if (!this.playoutsNumber){
                     o = {
                     date: this.conversionService.prepareObject(report.r0),
                     playouts: report.v1
                     };
                   }*/

      obj.data.push(o);
    }
    if (legendContainer) {
      obj.legendContainer = legendContainer;
    }
  }

  /*
                                     * old working code
                                     *
                                     * buildPlayerLineChart(obj, legendContainer?) {
                                      obj.data = [];
                                      obj.categoryType = 'date';
                                      for (const report of this.reportingObj.report.byDate) {
                                      const o = {
                                        date: this.conversionService.prepareObject(report.r0),
                                        playouts: report.v0,
                                        playbacktime: report.v1,
                                        visitors: report.v2,
                                        uniqueVisitors: report.v3,
                                        impressions: report.v4,
                                        screens: report.v5
                                      };
                                      obj.data.push(o);
                                      }
                                      if (legendContainer) {
                                      obj.legendContainer = legendContainer;
                                      }
                                      console.log(obj); //bernd code für wechsel, nächsten drei zeilen
                                      if (!this.playoutsNumber){
                                      obj.data.valueAssignments[0].value='playbacktime';
                                      }
                                      obj.loadingDone = true;
                                    }
                                     */

  buildPieChart() {
    this.pieChartData = {
      title: 'lcdType',
      height: 300,
      width: 100,
      value: 'value',
      category: 'category',
      fontSize: 23,
      sumLabel: false,
      legend: false,
      data: [],
      radius: 60,
    };
    if (this.reportingObj?.element) {
      if (this.playoutsNumber) {
        this.pieChartData.data = [
          {
            category: this.reportingObj.element.name,
            value: this.reportingObj.report.aggregated.v0,
            color: '#676fc6',
          },
          {
            category: 'Other',
            value: this.reportingObj.report.totalNumber.v0 - this.reportingObj.report.aggregated.v0,
            color: 'rgba(187,183,186,0.2)',
          },
        ];
        this.pieChartData.customLabel =
          Math.round((this.reportingObj.report.aggregated.v0 / this.reportingObj.report.totalNumber.v0) * 100) + '%';
      } else {
        this.pieChartData.data = [
          {
            category: this.reportingObj.element.name,
            value: this.reportingObj.report.aggregated.v1,
            color: '#676fc6',
          },
          {
            category: 'Other',
            value: this.reportingObj.report.totalNumber.v1 - this.reportingObj.report.aggregated.v1,
            color: 'rgba(187,183,186,0.2)',
          },
        ];
        this.pieChartData.customLabel =
          Math.round((this.reportingObj.report.aggregated.v1 / this.reportingObj.report.totalNumber.v1) * 100) + '%';
      }
    }
    if (this.pieChart) {
      this.pieChart.rerenderChart(this.pieChartData);
    }
  }

  sortDates(a, b) {
    if (a.r0.value === b.r0.value) {
      return a.r1 > b.r1 ? 1 : -1;
    }
    return a.r0 > b.r0 ? 1 : -1;
  }

  buildHeatmap(obj) {
    obj.data = [];
    for (const report of this.reportingObj.report.byHour) {
      report.r0 = this.conversionService.prepareObject(report.r0);
    }
    this.reportingObj.report.byHour.sort(this.sortDates);
    for (const report of this.reportingObj.report.byHour) {
      const varDate = report.r0.value.toFormat('dd.MM');
      let varHour;
      if (report.r1 < 10) {
        varHour = '0' + report.r1 + ':00 h';
      } else {
        varHour = report.r1 + ':00 h';
      }
      const o = {
        date: varDate,
        hour: varHour,
        visitors: report.v2,
        totalPlayouts: report.v0,
      };
      obj.data.push(o);
    }
  }
}
